import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

// Signed-in users without the member claim haven't passed the invite gate.
// Others are sent to sign in, then brought back to the page they asked for.
const PrivateRoute = ({ component: Component }) => {
  const { authUser, isMember } = useAuth();
  const location = useLocation();
  return authUser && isMember ? <Component /> : <Navigate to="/login" replace state={{ from: location }} />;
};

export default PrivateRoute;
